import { SVGProps } from 'react';

export const IconEvents = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='3 3 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4 11.2H20V17.6C20 18.9254 18.9255 20 17.6 20H6.4C5.07452 20 4 18.9254 4 17.6V11.2Z'
        fill='currentColor'
      />
      <path
        d='M4 9.59998H20V8.79998C20 7.47449 18.9255 6.39997 17.6 6.39997H6.4C5.07452 6.39997 4 7.47449 4 8.79998V9.59998Z'
        fill='currentColor'
      />
      <path
        d='M7.19995 4.8C7.19995 4.35817 7.55812 4 7.99995 4C8.44178 4 8.79995 4.35817 8.79995 4.8V7.2H7.19995V4.8Z'
        fill='currentColor'
      />
      <path
        d='M15.2 4.8C15.2 4.35817 15.5581 4 16 4C16.4418 4 16.8 4.35817 16.8 4.8V7.2H15.2V4.8Z'
        fill='currentColor'
      />
    </svg>
  );
};
